import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AppHeader } from '@teliaee/telia-megamenu';
import MenuStore from '@stores/MenuStore';
import TranslateStore from '@stores/TranslateStore';

interface HeaderProps {
  translateStore?: TranslateStore;
  menuStore?: MenuStore;
}

@inject('menuStore', 'translateStore')
@observer
class HeaderContainer extends React.Component<HeaderProps> {
  public render(): JSX.Element {
    if (this.props.translateStore.initializationCompleted) {
      return <AppHeader {...this.props.menuStore.getHeaderProps()} />;
    }
    return null;
  }
}

export default HeaderContainer;
